import "./Loader.scss";

import React from "react";

import { ConvUtils } from "./../../chart-components/ChartUtils/ConvUtils";
import PropTypes from "prop-types";
import loaderIcon from "./Loader.svg";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Loader({ hideMessage, progressData, errorData, chartData }) {
  const [secElapsed, setSecElapsed] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let iv = setInterval(() => {
      setSecElapsed((msElapsed) => msElapsed + 1);
    }, 1000);
    return () => clearInterval(iv);
  }, [setSecElapsed]);

  useEffect(() => {
    let lte = setTimeout(() => {
      console.log("this is taking longer time than expected");
    }, 10000);
    return () => clearTimeout(lte);
  }, [progressData.loaded]);

  let showSpinner = errorData.success;

  let showProcOnServer =
    !hideMessage &&
    errorData.success &&
    progressData.direction === "upload" &&
    (progressData.percent < 1 ||
      isNaN(progressData.percent) ||
      progressData.percent === 100);

  let showDownloading =
    !hideMessage &&
    errorData.success &&
    progressData.direction === "download" &&
    progressData.percent >= 1 &&
    !isNaN(progressData.percent);

  let showDownloadingZip =
    !showDownloading &&
    !hideMessage &&
    errorData.success &&
    progressData.direction === "download" &&
    progressData.loaded >= 1;

  let showCompleted =
    !showDownloading &&
    !hideMessage &&
    errorData.success &&
    progressData.direction === "completed" &&
    !chartData;

  let noData =
    !hideMessage &&
    errorData.success &&
    progressData.direction === "completed" &&
    chartData &&
    chartData.size() === 0;

  let showErrorOrEmpty = !hideMessage && !errorData.success;

  return (
    <div className="Loader-area">
      {!noData && showSpinner && (
        <img src={loaderIcon} className="Loader-icon" alt="Loading..." />
      )}
      {!noData && showCompleted && (
        <div className="Loader-progress-area">
          Nedlasting fullført, behandler lokalt...
        </div>
      )}
      {!noData && showProcOnServer && (
        <div className="Loader-progress-area">
          Behandler spørring på server i {secElapsed} sekund. Venligst vent.
          Hvis fremdriftsindikatoren blir stående å spinne lenge uten at det
          skjer noe har du trolig gjort et for stort utvalg. Gå tilbake til
          forrige side, juster utvalgskriteriene og prøv på nytt.
        </div>
      )}
      {!noData && showDownloading && (
        <div className="Loader-progress-area">
          Fremdrift: {+progressData.percent}% (
          {+ConvUtils.bytesToMB(+progressData.loaded, 1).toFixed(1)}/
          {+ConvUtils.bytesToMB(+progressData.total, 1).toFixed(1)}
          MB)
        </div>
      )}

      {!noData && showDownloadingZip && (
        <div className="Loader-progress-area">{`Fremdrift: lastet ${ConvUtils.bytesToMB(
          progressData.loaded,
          1
        ).toFixed(1)} MB på ${secElapsed} sekund`}</div>
      )}

      {showErrorOrEmpty &&
        !noData(
          <div className="Loader-progress-area">
            <p>Det oppstod ein feil under lasting av data.</p>
            <p className="extra">
              (Feilmelding: "{errorData.msg}
              ")
            </p>
            <button onClick={() => navigate(-1)}>Tilbake</button>
          </div>
        )}

      {noData && (
        <div className="Loader-progress-area">
          <p>
            Ingen data i utvalget. Du kan ha valgt en tidsperiode som det ikke
            finnes data for. Data kommer inn i løsningen med noen dager
            etterslep og data er kunn tilgjengelig noen år tilbake i tid.
          </p>
          <button onClick={() => navigate(-1)}>
            Gå tilbake til utvalggskjemaet og juster utvalget
          </button>
        </div>
      )}
    </div>
  );
  // }
}

Loader.propTypes = {
  hideMessage: PropTypes.bool,
  progressData: PropTypes.object,
  errorData: PropTypes.object,
  chartData: PropTypes.any,
};

Loader.defaultProps = {
  hideMessage: false,
  progressData: {
    direction: "upload",
    percent: 0,
    total: 0,
    loaded: 0,
    timeStamp: 0,
  },
  errorData: {
    success: true,
    msg: "ok",
  },
  history: null,
};
